export default "__VITE_ASSET__58e211aa__"